module.exports = __webpack_public_path__ + "img/pause.7a653c7b.svg";